import { Anchor, Container } from '@mantine/core';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import classes from './Footer.module.css';
import { trackEvent } from '../../utils/analytics.ts';

export default function Footer() {
    const { t } = useTranslation();

    const handleFooterNav = (label: string, destination: string) => {
        trackEvent('footer_link_click', { category: 'Navigation', label, destination });
    };

    return (
        <footer className={classes.footer}>
            <Container size="xl" className={classes.inner}>
                <span className={classes.footerText}>
                    Copyright © 2025 Promociones Montosa S.A.
                </span>
                <nav className={classes.links} aria-label="Legal">
                    <Anchor
                        component={Link}
                        to="/privacy-policy"
                        className={classes.link}
                        aria-label={t('footer.privacy')}
                        onClick={() => handleFooterNav(t('footer.privacy'), '/privacy-policy')}
                    >
                        {t('footer.privacy')}
                    </Anchor>
                    <Anchor
                        component={Link}
                        to="/terms-of-use"
                        className={classes.link}
                        aria-label={t('footer.terms')}
                        onClick={() => handleFooterNav(t('footer.terms'), '/terms-of-use')}
                    >
                        {t('footer.terms')}
                    </Anchor>
                </nav>
            </Container>
        </footer>
    );
}
